import React, { useEffect, useRef } from "react";
import { t } from "i18next";
import ApexCharts from "apexcharts";

const TotalGraph = ({
  split: { peopleAtTable, forPeople, totalAmount, remainingAmount, orderGrossAmount, splittedforPeople },
}) => {

  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const colors = Array.from({ length: peopleAtTable }, (_, i) =>
    i < forPeople + (splittedforPeople ?? 0)
      ? "var(--brand-base-primary)"
      : "var(--light-chart-brand-base-primary)"
  );

  const getOptions = () => ({
    series: Array(peopleAtTable).fill(100 / peopleAtTable),
    chart: {
      type: "donut",
      animations: { enabled: true },
    },
    labels: Array.from({ length: peopleAtTable }, (_, i) =>
      i < (splittedforPeople ?? 0)
        ? `${t("Person")} ${i + 1} ${t("already paid")}`
        : `${t("Person")} ${i + 1}`
    ),
    colors,
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        donut: {
          size: "85%",
          labels: {
            show: true,
            name: { color: "var(--brand-base-primary)" },
            value: {
              color: "var(--brand-base-primary)",
              formatter: () => {
                const amt = orderGrossAmount / peopleAtTable;
                return t("CAED", { amount: amt.toFixed(2) });
              },
            },
            total: {
              show: true,
              label: t("Total"),
              fontSize: "22px",
              fontWeight: 600,
              formatter: () => t("CAED", { amount: orderGrossAmount.toFixed(2) }),
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: () => {
          const amt = orderGrossAmount / peopleAtTable;
          return t("CAED", { amount: amt.toFixed(2) });
        },
      },
    },
  });

  useEffect(() => {
    if (!chartRef.current) return;

    // If chart exists, destroy it before re-creating
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const options = getOptions();
    chartInstance.current = new ApexCharts(chartRef.current, options);
    chartInstance.current.render();

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [peopleAtTable, forPeople, orderGrossAmount, remainingAmount, splittedforPeople]);

  return (
    <div className="chart-wrap d-flex justify-center">
      <div id="chart" ref={chartRef} />
    </div>
  );
};

export default TotalGraph;
